document.addEventListener('DOMContentLoaded', function(event) {
  //the event occurred

  gsap.registerPlugin(CSSPlugin);

  var observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      var delayInside = (entry.target.dataset.delay) ? entry.target.dataset.delay/1000 : 0; 
      var animationDirection = (entry.target.dataset.direction == 'rightToLeft') ? 124 : -124; 
      var animationSpeed = (entry.target.dataset.speed) ? entry.target.dataset.speed : 0.7; 
      if(entry.isIntersecting) {
        gsap.to(entry.target, {
          duration: animationSpeed,
          autoAlpha: 1,
          x: 0,
          delay: delayInside,
          ease: "power1.inOut"
        });
      } else {
        gsap.set(entry.target, {autoAlpha: 0, x: animationDirection});
      }
    });
  });

  var elAnimation = document.querySelectorAll('.ltr-animation');
  elAnimation.forEach((el) => observer.observe(el));

})